var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Upload',{ref:"upload",attrs:{"before-upload":_vm.handleBeforeUpload,"on-success":_vm.handleSuccess,"headers":_vm.headers,"format":_vm.format,"action":_vm.action}},[_c('Button',[_vm._v(_vm._s(_vm.btnText || _vm.$t('btn.choose')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }